import {WorkEntityKind} from "src/app/enums/WorkEntityKind.enum";
import {PeopleType} from "src/app/enums/People";
import {WorkEntitySuggestion} from "src/app/modules/shared/interfaces/WorkEntitySuggestion.interface";
import {CatalogSearchPresentation} from "src/app/modules/shared/interfaces/CatalogSearchPresentation.interface";

export function getCatalogSearchPresentation(
  entities: WorkEntitySuggestion[],
  hasOtherFilters: boolean
): CatalogSearchPresentation {
  const name = entities.map((entity) => entity.name).join(", ");
  let scope = "FILTERED";
  if (entities.length === 1) scope = getEntityScope(entities[0]);
  if (!entities.length && !hasOtherFilters) {
    return {
      placeholderKey: "CATALOG_SEARCH_PLACEHOLDER",
      params: {name},
    };
  }
  return {
    placeholderKey: `CATALOG_SEARCH_PLACEHOLDER_${scope}`,
    params: {name},
  };
}

function getEntityScope(entity: WorkEntitySuggestion): string {
  if (entity.kind === WorkEntityKind.Franchise) return "FRANCHISE";
  if (entity.kind === WorkEntityKind.Series) return "SERIES";
  if (entity.kind === WorkEntityKind.Company) return "STUDIO";
  if (entity.peopleType === PeopleType.Actor) return "ACTOR";
  if (entity.peopleType === PeopleType.Director) return "DIRECTOR";
  return "PERSON";
}
